import { Component } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface Founder {
  key: 'mahdi' | 'khalil';
  photo: string;
  initials: string;
  linkedin: string;
}

/**
 * Founders / team section.
 * Photos live in src/assets/team/ (mahdi.jpg, khalil.jpg). Until they exist,
 * each card falls back to an initials avatar.
 */
@Component({
  selector: 'app-landing-team',
  standalone: true,
  imports: [NgForOf, NgIf, TranslateModule],
  templateUrl: './landing-team.component.html',
  styleUrls: ['./landing-team.component.scss'],
})
export class LandingTeamComponent {
  readonly bullets = [0, 1, 2];

  readonly founders: Founder[] = [
    { key: 'mahdi', photo: 'assets/team/mahdi.jpg', initials: 'MF', linkedin: 'https://www.linkedin.com/in/mahdi-feki-1178a08b/' },
    { key: 'khalil', photo: 'assets/team/khalil.jpg', initials: 'KA', linkedin: 'https://www.linkedin.com/in/khalil-abdelmalek-339b009a/' },
  ];

  failedPhoto: Record<string, boolean> = {};

  onError(key: string): void {
    this.failedPhoto[key] = true;
  }
}
